<template>
  <div class="receptionOverflow">
    <div :class="setUrlStatus == 2 ? 'flex' : 'hidden'">
      <el-row class="rowTop">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span v-popover:popover1 class="h_three black">{{ indexMsg.sumTotal }}</span>
            <h5>今日收入</h5>
            <el-popover ref="popover1" placement="right-start" :trigger="uaValue === 'pc' ? 'hover' : 'click'" :disabled="indexMsg.sumTotal*1 == 0">
              <div class="home_right_info">
                <span v-for="(item,index) in indexMsg.payList" :key="index">
                  <p v-if="item.amount">
                    {{ item.payTypeName }}:
                    <span>￥{{ item.amount }}</span>
                  </p>
                </span>
              </div>
            </el-popover>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <span v-popover:popover2 class="h_three black">{{ indexMsg.totalCount }}</span>
            <h5>今日消费人次</h5>
            <el-popover ref="popover2" placement="right-start" :trigger="uaValue === 'pc' ? 'hover' : 'click'" :disabled="indexMsg.totalCount*1 == 0">
              <div class="home_right_info">
                <div class="arrow">
                  <em></em>
                  <label></label>
                </div>
                <p>
                  会员人次:
                  <span>{{ indexMsg.count4Member }}</span>
                </p>
                <p>
                  非会员人次:
                  <span>{{ indexMsg.count4NoMember }}</span>
                </p>
              </div>
            </el-popover>
          </div>
        </el-col>

        <el-col :span="4">
          <div class="grid-content bg-purple">
            <h3 class="black">{{ indexMsg.beautyCardBuyCount }}</h3>
            <h5>今日办理套餐数</h5>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <h3 class="black">{{ indexMsg.orderCount }}</h3>
            <h5>今日预约人数</h5>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <h3 class="black">{{ indexMsg.memberAddCount }}</h3>
            <h5>今日新增会员</h5>
          </div>
        </el-col>
      </el-row>
      <div class="navTitle">常用功能</div>
      <div v-if="screenWidth > 1280" class="navList">
        <ul>
          <li @click="addTab('stage-serviceBilling')">
            <img src="static/images/icon/new_list_01.png" />
            <span>服务开单</span>
          </li>
          <li @click="addTab('stage-quickCashier')">
            <img src="static/images/icon/new_list_02.png" />
            <span>快捷收银</span>
          </li>
          <li @click="addTab('stage-attendance')">
            <img src="static/images/icon/new_list_03.png" />
            <span>今日出勤</span>
          </li>
          <li @click="addTab('stage-bespeakService')">
            <img src="static/images/icon/new_list_04.png" />
            <span>新增预约</span>
          </li>
          <li @click="getMemberUrl">
            <img src="static/images/icon/new_list_05.png" />
            <span>新增会员</span>
          </li>
          <li @click="addTab('stage-beautyCard')">
            <img src="static/images/icon/new_list_06.png" />
            <span>套餐办理/划扣</span>
          </li>
        </ul>
        <ul>
          <li @click="addTab('credit-index')">
            <img src="static/images/icon/new_list_07.png" />
            <span>赊账管理</span>
          </li>
          <li @click="addTab('stage-cashBox')">
            <img src="static/images/icon/new_list_08.png" />
            <span>钱箱管理</span>
          </li>
          <li @click="addTab('stage-setScheduling')">
            <img src="static/images/icon/new_list_10.png" />
            <span>设置排班</span>
          </li>
          <li @click="addTab('stage-commentAnalyse')">
            <img src="static/images/icon/new_list_11.png" />
            <span>评价分析</span>
          </li>
          <li @click="addTab('attendance-record')">
            <img src="static/images/icon/new_list_09.png" />
            <span>出勤记录</span>
          </li>
          <li @click="addTab('stage-coupon')">
            <img src="static/images/icon/new_list_14.png" />
            <span>优惠券管理</span>
          </li>
        </ul>
      </div>
      <div v-else class="navList">
        <ul>
          <li @click="addTab('stage-serviceBilling')">
            <img src="static/images/icon/new_list_01.png" />
            <span>服务开单</span>
          </li>
          <li @click="addTab('stage-quickCashier')">
            <img src="static/images/icon/new_list_02.png" />
            <span>快捷收银</span>
          </li>
          <li @click="addTab('stage-attendance')">
            <img src="static/images/icon/new_list_03.png" />
            <span>今日出勤</span>
          </li>
          <li @click="addTab('stage-bespeakService')">
            <img src="static/images/icon/new_list_04.png" />
            <span>新增预约</span>
          </li>
        </ul>
        <ul>
          <li @click="getMemberUrl">
            <img src="static/images/icon/new_list_05.png" />
            <span>新增会员</span>
          </li>
          <li @click="addTab('stage-beautyCard')">
            <img src="static/images/icon/new_list_06.png" />
            <span>套餐办理/划扣</span>
          </li>
          <li @click="addTab('credit-index')">
            <img src="static/images/icon/new_list_07.png" />
            <span>赊账管理</span>
          </li>
          <li @click="addTab('stage-cashBox')">
            <img src="static/images/icon/new_list_08.png" />
            <span>钱箱管理</span>
          </li>
        </ul>
        <ul>
          <li @click="addTab('stage-setScheduling')">
            <img src="static/images/icon/new_list_10.png" />
            <span>设置排班</span>
          </li>
          <li @click="addTab('stage-commentAnalyse')">
            <img src="static/images/icon/new_list_11.png" />
            <span>评价分析</span>
          </li>
          <li @click="addTab('attendance-record')">
            <img src="static/images/icon/new_list_09.png" />
            <span>出勤记录</span>
          </li>
          <li @click="addTab('stage-coupon')">
            <img src="static/images/icon/new_list_14.png" />
            <span>优惠券管理</span>
          </li>
        </ul>
      </div>
      <div class="navTitle" style="margin-top: 10px;">待办事项</div>
      <div class="navListTwo">
        <div class="navLi" @click="addTab('service-order')">
          <div class="navBg">
            <i class="iconfont themeFC">&#xe606;</i>
          </div>
          <span>待结算订单</span>
          <label>
            <samp class="themeFC">{{ indexMsg.payOrderCount }}</samp>个订单</label>
        </div>
        <div class="navLi" @click="addTab('stage-reservationList')">
          <div class="navBg">
            <i class="iconfont themeFC">&#xe608;</i>
          </div>
          <span>近期待处理预约</span>
          <label>
            <samp class="themeFC">{{ indexMsg.waitBookOrderCount }}</samp>个预约</label>
        </div>
      </div>
      <div class="navTitle">值班状态</div>
      <div class="staffStatus">
        <div class="liLeft" :style="moreStatusOne ? '' : returnCss(servicingList.length)">
          <h3>服务中（{{ servicingList.length }}人）</h3>
          <h5 v-if="moreStatusOne ? false : returnStatus(servicingList.length)"><span @click="moreStatusOne = true">查看更多 <i class="el-icon-arrow-down"></i></span></h5>
          <h1 v-for="(item,index) in servicingList" :key="index">
            <img v-if="item.headUrl" :src="item.headUrl" />
            <div v-else class="noImg">
              <i class="iconfont">&#xe719;</i>
            </div>
            <div>
              <span>{{ item.technicianName }}</span>
              <label>
                <samp v-for="(list,val) in item.clientItemList" :key="val">{{ list.serveItmeName }}{{ item.clientItemList.length == (val*1+1) ? '' : '，' }}</samp>
              </label>
            </div>
          </h1>
          <h4 v-if="!moreStatusOne ? false : returnStatus(servicingList.length)"><span @click="moreStatusOne = false">收起 <i class="el-icon-arrow-up"></i></span></h4>
          <!-- <p v-for="(item,index) in servicingList" :key="index">
                        <span>
                            <samp v-for="(list,val) in item.clientItemList" :key="val">{{list.clientName}} | {{list.serveItmeName}}{{item.clientItemList.length == (val*1+1) ? '' : '，'}}</samp>
                        </span>
                        <label><img :src="item.headUrl ? item.headUrl : 'static/images/head.png'" />{{item.technicianName}}</label>
                    </p> -->
        </div>
        <div class="liRight" :style="moreStatusTwo ? '' : returnCss(freeList.length)">
          <h3>空闲（{{ freeList.length }}人）</h3>
          <h5 v-if="moreStatusTwo ? false : returnStatus(freeList.length)"><span @click="moreStatusTwo = true">查看更多 <i class="el-icon-arrow-down"></i></span></h5>
          <p v-for="(item,index) in freeList" :key="index">
            <img v-if="item.headUrl" :src="item.headUrl" />
            <b v-else class="noImg">
              <i class="iconfont">&#xe719;</i>
            </b>
            <!-- <samp>{{item.job ? item.job : '--'}}</samp> -->
            <span>{{ item.technicianName ? item.technicianName : '--' }}</span>
          </p>
          <h4 v-if="!moreStatusTwo ? false : returnStatus(freeList.length)"><span @click="moreStatusTwo = false">收起 <i class="el-icon-arrow-up"></i></span></h4>
        </div>
      </div>
    </div>

    <!-- <div :class="setUrlStatus == 1 && mainId == 0 ? 'flex' : 'hidden'">
            <img style="margin: 80px auto 20px auto;display: block;" src="../../assets/images/noneData.gif">
            <p style="text-align: center;color: #333;font-size: 14px;height: 30px;line-height: 30px;">{{setMenuMsg == 0 ? '该账号没有设置菜单' : '你还没有创建门店，请前往创建与添加信息！'}}</p>
            <el-button v-if="setMenuMsg == 1" style="margin: 50px auto 20px auto;display: block;" type="primary" @click="jumpPage">创建门店</el-button>
        </div> -->

    <div v-show="setUrlStatus == 1 && !mainId" class="nosetShop">
      <img src="../../assets/images/noShop_01.png">
      <p>使用系统前，请完善基础信息</p>
      <div class="stepList">
        <h1>系统初始设置流程</h1>
        <div class="step one">
          <div class="li">
            <h2>步骤1：完善商家信息</h2>
            <el-button type="primary" :class="setMenuMsg == 1 ? 'themeFC' : ''" :style="setMenuMsg == 1 ? 'background-color: #fff !important;' : ''" :disabled="setMenuMsg == 1 ? true : false" @click="setMenuMsg == 1 ? '' : jumpPage()">{{ setMenuMsg == 1 ? '已完成' : '前往设置' }}</el-button>
          </div>
          <div class="li width1">
            <i class="iconfont i_1">&#xe700;</i>
            <h3>创建门店</h3>
          </div>
          <div class="li width2">
            <i class="iconfont i_2">&#xe62c;</i>
          </div>
          <div class="li width1">
            <i class="iconfont i_1">&#xe719;</i>
            <h3>配置角色权限</h3>
          </div>
          <div class="li width2">
            <i class="iconfont i_2">&#xe62c;</i>
          </div>
          <div class="li width1">
            <i class="iconfont i_1">&#xe8f0;</i>
            <h3>新增员工账号</h3>
          </div>
        </div>
        <div class="step">
          <div class="li">
            <h2>步骤2：录入店铺信息</h2>
            <el-button type="primary" :style="setMenuMsg == 0 ? 'background-color: #f4f4f5 !important;border: solid 1px #e9e9eb !important;color: #bcbec2 !important;' : ''" :disabled="setMenuMsg == 0 ? true : false" @click="jumpPage">前往设置</el-button>
          </div>
          <div class="li width1">
            <i class="iconfont i_1">&#xe698;</i>
            <h3>创建店铺</h3>
          </div>
          <div class="li width2">
            <i class="iconfont i_2">&#xe62c;</i>
          </div>
          <div class="li width1">
            <i class="iconfont i_1">&#xe673;</i>
            <h3>新增服务项目</h3>
          </div>
          <div class="li width2">
            <i class="iconfont i_2">&#xe62c;</i>
          </div>
          <div class="li width1">
            <i class="iconfont i_1">&#xe697;</i>
            <h3>设置{{ Lib.collectively() }}</h3>
          </div>
          <div class="li width2">
            <i class="iconfont i_2">&#xe62c;</i>
          </div>
          <div class="li width1">
            <i class="iconfont i_1">&#xe696;</i>
            <h3>通用设置</h3>
          </div>
        </div>
      </div>
    </div>

    <gt-memberDig @memberUrl="memberUrl"></gt-memberDig>
  </div>
</template>
<script>
import { getIndexMsg, getSignSuccess, getVacationListByStatus } from './api';

export default {
  data() {
    return {
      form: {
        memberDialog: false // 新增会员弹框
      },
      indexMsg: {}, // 前台数据参数信息
      setUrl: '', // 链接后台创建店铺地址
      setUrlStatus: 0, // 是否有店铺的状态
      mainId: '', // 店铺ID
      setMenuMsg: '', // 菜单内容
      screenWidth: document.body.clientWidth, // 窗口宽度
      servicingList: [], // 服务中列表
      freeList: [], // 空闲列表
      uaValue: '', // 判断是手机端还是PC端   pc为PC端，mobile为手机端
      menusList: [],
      moreStatusOne: false,
      moreStatusTwo: false,
    };
  },
  created() {
    const vm = this;
    vm.uaValue = vm.Lib.pcOrMobile();
    $(window).resize(() => {
      vm.screenWidth = document.body.clientWidth;
    });
    this.menusList = JSON.parse(sessionStorage.getItem('menusList'));
  },
  activated() {
    const vm = this;
    getSignSuccess().then((res) => {
      if (res.code === 0) {
        sessionStorage.setItem('isPercentage', res.data.isPercentage);
        sessionStorage.setItem('isPackageTime', res.data.isPackageTime);
        this.menusList = res.data.menusList;
        if (res.data.status == 111) {
          vm.setUrl = res.data.setUrl4Shop;
          vm.setUrlStatus = 1;
          vm.setMenuMsg = 0;
          return;
        }
        if (res.data.status == 222) {
          vm.setUrl = res.data.setUrl;
          vm.setUrlStatus = 1;
          vm.setMenuMsg = 1;
          return;
        }
        vm.mainId = res.data.storeId;
        vm.setUrlStatus = 2;
      } else {
        vm.setUrlStatus = 1;
        vm.setMenuMsg = 0;
      }
      vm.getTodayData();
    });
    // this.menusList = JSON.parse(sessionStorage.getItem('menusList'))
  },
  methods: {
    // 值班状态--样式判断
    returnCss(val) {
      if (this.screenWidth > 1280) {
        if (val > 18) {
          return 'height: 486px;overflow: hidden;';
        }
        return '';
      }
      if (val > 12) {
        return 'height: 486px;overflow: hidden;';
      }
      return '';
    },
    // 值班状态--是否有更多判断
    returnStatus(val) {
      if (this.screenWidth > 1280) {
        if (val > 18) {
          return true;
        }
        return false;
      }
      if (val > 12) {
        return true;
      }
      return false;
    },
    // 跳转商家后台创建门店
    jumpPage() {
      window.open(this.setUrl);
    },
    // 添加tab栏
    addTab(name) {
      if (name == 'stage-serviceBilling') {
        if (this.Lib.checkPower('beauty-2-fwkd') == false) return;
        if (name == 'stage-serviceBilling') {
          window.sessionStorage.editOrderId = '';
          window.sessionStorage.userName = '';
          window.sessionStorage.userPhone = '';
          window.sessionStorage.bookOrderId = '';
        }
      } else if (name == 'stage-quickCashier') {
        if (this.Lib.checkPower('beauty-2-kjsy') == false) return;
      } else if (name == 'stage-beautyCard') {
        if (this.Lib.checkPower('beauty-2-tcbl') == false) return;
      } else if (name == 'stage-addReservationList') {
        window.sessionStorage.bespeakId = '';
      } else if (name == 'stage-bespeakService') {
        if (this.Lib.checkPower('beauty-2-xzyyyyxm') == false && this.Lib.checkPower('beauty-2-xzyyyyjs') == false) return;
      } else if (name == 'stage-reservationList') {
        if (this.Lib.checkPower('beauty-2-ckyy') == false) return;
      } else if (name == 'service-order') {
        if (this.Lib.checkPower('beauty-2-ckdd') == false) return;
      } else if (name == 'credit-index') {
        if (this.Lib.checkPower('beauty-2-szgl') == false) return;
      } else if (name == 'stage-cashBox') {
        if (this.Lib.checkPower('beauty-2-qxgl') == false) return;
      } else if (name == 'stage-setScheduling') {
        if (this.Lib.checkPower('beauty-2-pbsz') == false) return;
      } else if (name == 'stage-commentAnalyse') {
        if (this.Lib.checkPower('beauty-2-pjfx') == false) return;
      } else if (name == 'attendance-record') {
        if (this.Lib.checkPower('beauty-2-cqjl') == false) return;
      } else if (name == 'stage-coupon') {
        if (this.Lib.checkPower('beauty-2-yhqgl') == false) return;
      } else if (name == 'stage-attendance') {
        if (this.Lib.checkPower('beauty-2-jrcq') == false) return;
      }
      this.$router.push({
        name,
        params: {
          activeName: 'second'
        }
      });
    },
    // 获取今天收入信息
    getTodayData() {
      const vm = this;
      const data = {};
      getIndexMsg(data).then((res) => {
        vm.indexMsg = res.data;
        if (res.data.noReadCount == 0) {
          $('#socketBespeakStatus').css('display', 'none');
        } else {
          $('#socketBespeakStatus').text(res.data.noReadCount);
        }
        vm.getVacationList(0);
        vm.getVacationList(1);
      });
    },
    // 调用公共组件--赋值
    memberUrl(list) {
      this.form = list;
    },
    // open 新增会员
    getMemberUrl() {
      if (this.Lib.checkPower('beauty-2-hybl') == false) return;
      this.form.memberDialog = true;
    },
    // 获得员工当前值班状态信息   0:服务中,1:空闲,2:请假,3:休假
    getVacationList(status) {
      const data = {
        status
      };
      getVacationListByStatus(data).then((res) => {
        if (res.code == 0) {
          res.data.forEach((a) => {
            if (a.headUrl) a.headUrl += '?x-oss-process=image/resize,m_lfit,w_80,h_80';
          });
          if (status == 0) {
            this.servicingList = res.data ? res.data : [];
          } else if (status == 1) {
            this.freeList = res.data ? res.data : [];
          }
        } else {
          // console.log(res)
        }
      });
    }
  }
};
</script>

<style>
.el-menu {
  border-right: 0 !important;
}
</style>

<style scoped>
.chooseShop .iconfont {
  font-family: "iconfont" !important;
  font-size: 22px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  padding: 0 130px;
  position: relative;
  top: 3px;
  right: -120px;
}
.receptionOverflow .flex {
  flex: 1;
}
.receptionOverflow .rowTop {
  width: 100%;
  height: 100px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
}
.receptionOverflow .rowTop .el-col-4 {
  padding: 20px 0;
  height: 60px;
}
.receptionOverflow .rowTop .el-col-6 {
  padding: 20px 0;
  height: 60px;
}

.receptionOverflow .rowMiddle {
  margin-top: 20px;
  display: flex;
}
.hoverHidden:hover {
  position: relative;
  z-index: 999;
}
.receptionOverflow .rowMiddle .mr_2 {
  margin-right: 2px;
}
.receptionOverflow .rowMiddle .el-col-6 {
  height: 60px;
  background-color: #f9f9f9;
  line-height: 60px;
}
.receptionOverflow .rowMiddle .el-col-6:hover {
  background-color: #ecf5ff;
  cursor: pointer;
}
.receptionOverflow .rowMiddle .el-col-6 img {
  width: 28px;
  height: 28px;
  margin: 16px 15px 16px 30px;
  float: left;
}
.receptionOverflow .rowMiddle .el-col-6 span {
  color: #333;
  font-size: 14px;
}

.indexEqcode {
  width: 100%;
}
.indexEqcode li {
  float: left;
  margin: 0 15px;
  list-style-type: none;
}
.indexEqcode li img {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.indexEqcode li h5 {
  text-align: center;
  font-size: 12px;
  padding: 5px 0;
}
.indexEqcode li h6 {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.el-menu-vertical-demo .iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 100 !important;
  color: #fff;
  position: relative;
  top: 2px;
}
.el-menu-vertical-demo .menuFixed {
  position: fixed;
  bottom: 50px;
}
.staffStatus .liLeft p span {
  width: calc(100% - 120px);
}
</style>

<style lang="less" scoped>
.navList {
  width: 100%;
  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      height: 60px;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      flex: 1;
      margin: 0 20px 20px 0;
      cursor: pointer;
      img {
        width: 34px;
        height: 34px;
        margin: 13px 20px;
        float: left;
      }
      span {
        font-size: 14px;
        color: #333;
        height: 40px;
        line-height: 40px;
        float: left;
        margin: 10px 0;
      }
    }
    li:last-child {
      margin-right: 0;
    }
  }
}
.navListTwo {
  width: 100%;
  display: flex;
  .navLi:first-child .navBg i {
    font-size: 18px;
  }
  .navLi {
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    flex: 1;
    padding: 0 20px;
    margin-right: 20px;
    cursor: pointer;
    .navBg {
      background-color: #fff;
      margin: 12px 0;
      border-radius: 10px;
      box-shadow: 0px 4px 10px 0px rgba(53, 53, 53, 0.05);
      width: 36px;
      height: 36px;
      transform: rotate(45deg);
      -ms-transform: rotate(45deg); /* IE 9 */
      -moz-transform: rotate(45deg); /* Firefox */
      -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
      -o-transform: rotate(45deg); /* Opera */
      float: left;
      i {
        display: block;
        font-size: 22px;
        line-height: 36px;
        text-align: center;
        transform: rotate(-45deg);
        -ms-transform: rotate(-45deg); /* IE 9 */
        -moz-transform: rotate(-45deg); /* Firefox */
        -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
        -o-transform: rotate(-45deg); /* Opera */
      }
    }
    span {
      font-size: 14px;
      color: #333;
      float: left;
      padding-left: 15px;
    }
    label {
      float: right;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      samp {
        font-size: 26px;
        font-weight: 600;
      }
    }
  }
  .navLi:last-child {
    margin-right: 0;
  }
}
.staffStatus {
  width: 100%;
  display: flex;
  .liLeft {
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    flex: 1;
    padding: 0 20px;
    margin-right: 20px;
    overflow: hidden;
    h3 {
      height: 55px;
      line-height: 55px;
      font-size: 14px;
      color: #333;
      border-bottom: 1px solid #f5f5f5;
      margin-bottom: 10px;
    }
    h5 {
      position: relative;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-bottom: -60px;
      bottom: -360px;
      background-color: #fff;
      width: 102%;
      left: -1%;
      span {
        padding: 10px 15px;
        cursor: pointer;
      }
    }
    h4 {
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #999;
      text-align: center;
      background-color: #fff;
      width: 102%;
      left: -1%;
      display: inline-block;
      span {
        padding: 10px 15px;
        cursor: pointer;
      }
    }
    p {
      height: 60px;
      line-height: 60px;
      color: #999;
      font-size: 14px;
      span {
        display: block;
        float: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        samp {
          padding-left: 10px;
        }
      }
      label {
        float: right;
        color: #333;
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin: 10px;
          float: left;
        }
      }
    }
    h1 {
      width: 33.3%;
      float: left;
      height: 60px;
      line-height: 60px;
      color: #999;
      font-size: 14px;
      .noImg {
        color: #999;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #fff;
        display: block;
        border-radius: 50%;
        box-shadow: 0px 5px 10px 0px rgba(53, 53, 53, 0.15);
        float: left;
        margin: 10px 0;
        i {
          font-size: 28px;
        }
      }
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        box-shadow: 0px 5px 10px 0px rgba(53, 53, 53, 0.15);
        float: left;
        margin: 10px 0;
      }
      div {
        height: 40px;
        float: left;
        display: contents;
        label {
          display: block;
          height: 20px;
          line-height: 20px;
          color: #999;
          padding: 0 10px 10px 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
        }
        span {
          display: block;
          height: 20px;
          line-height: 20px;
          color: #333;
          padding: 10px 10px 0 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    @media only screen and (max-width: 1280px) {
      h1 {
        width: 50% !important;
      }
    }
  }
  .liRight {
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    flex: 1;
    padding: 0 20px;
    h3 {
      height: 55px;
      line-height: 55px;
      font-size: 14px;
      color: #333;
      border-bottom: 1px solid #f5f5f5;
      margin-bottom: 10px;
    }
    h5 {
      position: relative;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-bottom: -60px;
      bottom: -360px;
      background-color: #fff;
      width: 102%;
      left: -1%;
      span {
        padding: 10px 15px;
        cursor: pointer;
      }
    }
    h4 {
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #999;
      text-align: center;
      background-color: #fff;
      width: 102%;
      left: -1%;
      display: inline-block;
      span {
        padding: 10px 15px;
        cursor: pointer;
      }
    }
    @media only screen and (max-width: 1280px) {
      p {
        width: 50% !important;
      }
    }
    p {
      width: 33.3%;
      float: left;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      display: flex;
      .noImg {
        color: #999;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #fff;
        display: block;
        border-radius: 50%;
        box-shadow: 0px 5px 10px 0px rgba(53, 53, 53, 0.15);
        float: left;
        margin: 10px 0;
        font-weight: 500;
        i {
          font-size: 28px;
        }
      }
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        box-shadow: 0px 5px 10px 0px rgba(53, 53, 53, 0.15);
        float: left;
        margin: 10px 0;
      }
      samp {
        flex: 1;
        color: #999;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        flex: 1;
        color: #333;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.nosetShop {
  display: block;
  margin: 0 auto;
  width: 824px;
  img {
    display: block;
    margin: 40px auto 10px auto;
  }
  p {
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    color: #333;
    text-align: center;
  }
  .stepList::after {
    display: table;
    content: "";
    clear: both;
  }
  .stepList {
    margin-top: 40px;
    padding: 0 30px 30px 30px;
    border: 1px solid #dfe4ed;
    h1 {
      position: relative;
      top: -10px;
      margin: 0 auto;
      width: 160px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      background-color: #fff;
      color: #666;
    }
    .step {
      padding-top: 40px;
      height: 100px;
      .width1 {
        width: 98px;
      }
      .width2 {
        width: 20px;
      }
      .li {
        float: left;
        padding-right: 20px;
        .i_1 {
          display: block;
          text-align: center;
          margin-top: 10px;
          font-size: 40px;
          color: #ccc;
        }
        .i_2 {
          display: block;
          margin-top: 30px;
          font-size: 20px;
          color: #ccc;
        }
        h2 {
          height: 20px;
          line-height: 20px;
          font-size: 15px;
          color: #666;
          margin-bottom: 20px;
        }
        h3 {
          text-align: center;
          height: 20px;
          line-height: 20px;
          font-size: 15px;
          color: #666;
        }
      }
    }
    .one {
      border-bottom: 1px dashed #dfe4ed;
    }
  }
}
.navTitle {
  height: 15px;
  line-height: 15px;
  color: #999;
  margin: 30px 0 15px 0;
}
.h_three {
  font-size: 26px;
  height: 35px;
  line-height: 35px;
  font-weight: 500;
  cursor: pointer;
  padding: 0 10px;
}
</style>
